import React from 'react';
import PropTypes from 'prop-types';


function LicenseRenderer(props) {
  const { value, data } = props;
  if (!data || !data._id) {
    return null;
  }
  if (value === null) {
    return (<em className="text-muted">N/A</em>);
  }
  return (
    <span className={`label ${(value ? 'label-success' : 'label-danger')}`}>{(value ? 'YES' : 'NO')}</span>
  );
}

LicenseRenderer.propTypes = {
  value: PropTypes.bool,
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
};
LicenseRenderer.defaultProps = {
  value: null,
};

export default LicenseRenderer;
